import React from "react";
import { PRIVACY_URL, TERMS_URL } from "../utils/support";

// Shown before anyone buys or renews a plan: going ahead means agreeing to these (the backend records when)
export default function TermsNote() {
  return (
    <p className="terms-note">
      By continuing with a free trial or any paid plan, you agree to Ownezzy's{" "}
      <a href={TERMS_URL} target="_blank" rel="noreferrer">Terms of Service</a> and{" "}
      <a href={PRIVACY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>. Plan payments are not refundable.
    </p>
  );
}
